export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/onboarding-close.png?fcf97be80448bcc424c8d68916260499";